module.exports = __webpack_public_path__ + "static/media/rm2.a123d5a8.jpg";